import { useState } from 'react'
import arrowRight from '../../../../assets/icons/arrowRight.svg'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../redux'
import libertyLakeSlice from '../../../../redux/slice/libertyLake.slice'
import { LibertyLakeFamilyInfo, LibertyLakeKid } from '../../../../types/libertyLakeV2'

const Step1 = () => {
  const dispatch: AppDispatch = useDispatch()
  const campersOptions = [1, 2, 3, 4, 5]
  const { kids, familyInfo } = useSelector((state: RootState) => state.libertyLake)
  const [camperDropdown, showCamperDropdown] = useState(false)

  const updateFamilyInfo = (updates: Partial<LibertyLakeFamilyInfo>) => {
    dispatch(libertyLakeSlice.actions.setFamilyInfo({ ...familyInfo, ...updates }))
  }

  return <>
    <div className='step1'>
      <div className="row">
        <div className="inputFieldArea">
          <label className='fieldLabel'>Your First Name<span className='required'>*</span></label>
          <input
            type="text"
            className='inputField'
            placeholder='John'
            value={familyInfo.firstName}
            onChange={(e) => updateFamilyInfo({ firstName: e.target.value })}
          />
        </div>
        <div className="inputFieldArea">
          <label className='fieldLabel'>Your Last Name<span className='required'>*</span></label>
          <input
            type="text"
            className='inputField'
            placeholder='Doe'
            value={familyInfo.lastName}
            onChange={(e) => updateFamilyInfo({ lastName: e.target.value })}
          />
        </div>
      </div>
      <div className="row">
        <div className="inputFieldArea">
          <label className='fieldLabel'>Your Email<span className='required'>*</span></label>
          <input
            type="email"
            className='inputField'
            placeholder='email@example.com'
            value={familyInfo.email}
            onChange={(e) => updateFamilyInfo({ email: e.target.value })}
          />
        </div>
        <div className="inputFieldArea">
          <label className='fieldLabel'>Your Phone Number</label>
          <input
            type="text"
            className='inputField'
            placeholder='987 654 3210'
            value={familyInfo.phone}
            onChange={(e) => updateFamilyInfo({ phone: e.target.value })}
          />
        </div>
      </div>
      <div className='row'>
        <div className="inputFieldArea">
          <label className='fieldLabel'>City<span className='required'>*</span></label>
          <input
            type="text"
            className='inputField'
            placeholder='City'
            value={familyInfo.city}
            onChange={(e) => updateFamilyInfo({ city: e.target.value })}
          />
        </div>
        <div className="inputFieldArea">
          <label className='fieldLabel'>Select Number of Camper(s)<span className='required'>*</span></label>
          <div
            className="selectInputFieldArea"
            onClick={() => showCamperDropdown(true)}
          >
            {kids.length > 0 ? kids.length : 'Select...'}
            <img className='arrowIcon' src={arrowRight} />
          </div>
          {camperDropdown
            ? (
              <div className="dropdownContainer">
                {campersOptions.map((noOfCamper: number, index: number) => (
                  <div
                    className='dropdownOption'
                    key={`${noOfCamper}:${index}`}
                    onClick={() => {
                      const kidList: LibertyLakeKid[] = []
                      for (let i = 0; i < noOfCamper; i++) {
                        kidList.push({
                          id: `Camper ${i + 1}`,
                          grade: '',
                          weeksTotal: 0,
                          includeAMBus: false,
                          includePMBus: false
                        })
                      }
                      dispatch(libertyLakeSlice.actions.setKids(kidList))
                      showCamperDropdown(false)
                    }}
                  >
                    {noOfCamper}
                  </div>
                ))}
              </div>
            )
            : ''}
        </div>
      </div>
    </div>
    {camperDropdown && <div className='backDrop' onClick={() => showCamperDropdown(false)} />}
  </>
}

export default Step1
